import { z } from 'zod';

export const cargoIdRequestSchema = z.object({
  full_name: z
    .string()
    .trim()
    .min(2, 'cargoId:errors.fullNameRequired')
    .max(255, 'cargoId:errors.tooLong'),
  phone_number: z.string().trim().min(1, 'cargoId:errors.phoneRequired'),
  type: z.enum(['PHYSICAL', 'LEGAL']),
});

export type CargoIdRequestValues = z.infer<typeof cargoIdRequestSchema>;

export const cargoIdConnectSchema = z.object({
  code: z.string().trim().min(1, 'cargoId:errors.codeRequired'),
  full_name: z
    .string()
    .trim()
    .min(2, 'cargoId:errors.fullNameRequired')
    .max(255, 'cargoId:errors.tooLong'),
  phone_number: z.string().trim().min(1, 'cargoId:errors.phoneRequired'),
});

export type CargoIdConnectValues = z.infer<typeof cargoIdConnectSchema>;
